import TagIds from '~/constants/common/tagIds';
import { getVehicleDetails } from '~/selectors';
import useSelector from '~/store/useSelector';

export type AdditionalHighlightInfo = {
  title: string;
  iconSrc: string;
  condition: boolean;
};

export default function useGetAdditionalHighlights(): AdditionalHighlightInfo[] {
  const {
    highlights,
    remainingWarrantyMonths = 0,
    remainingWarrantyMiles = 0
  } = useSelector(getVehicleDetails);

  const showNoAccidents =
    highlights?.some(
      highlight => highlight.tagId === TagIds.NoReportedAccidents
    ) ?? false;
  const showSingleOwner =
    highlights?.some(highlight => highlight.tagId === TagIds.SingleOwner) ??
    false;
  const hasOriginalWarranty =
    remainingWarrantyMonths > 1 && remainingWarrantyMiles > 0;
  const hasLowMileageTag =
    highlights?.some(highlight => highlight.tagId === TagIds.LowMileage) ??
    false;
  const hasLowMilesPerYearTag =
    highlights?.some(highlight => highlight.tagId === TagIds.LowMilesPerYear) ??
    false;
  const showLowMileage = hasLowMileageTag || hasLowMilesPerYearTag;

  return [
    {
      title: 'No Reported Accidents',
      iconSrc: '/svgs/additional-highlights/vehicle-checkmark-32px.svg',
      condition: showNoAccidents
    },
    {
      title: 'Single Owner',
      iconSrc: '/svgs/additional-highlights/vehicle-halo-circle-32px.svg',
      condition: showSingleOwner
    },
    {
      title: 'Original Warranty Active',
      iconSrc: '/svgs/additional-highlights/shield-checkmark-32px.svg',
      condition: hasOriginalWarranty
    },
    {
      title: hasLowMileageTag ? 'Low Mileage' : 'Low Miles Per Year',
      iconSrc: '/svgs/additional-highlights/low-odometer-32px.svg',
      condition: showLowMileage
    }
  ].filter(item => item.condition);
}
